import styled from '@emotion/styled/macro';

export const ContentWrapper = styled.div`
    width: 100%;
    text-align: center;
    padding: 0 ${props => props.theme.spacing.large} 0
        ${props => props.theme.spacing.large};
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    @media (min-width: 1024px) {
        padding: 0;
    }
`;

export const Title = styled.h1`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.xlarge};
    margin-bottom: 24px;
    text-align: center;
    text-transform: uppercase;
`;

export const SubTitle = styled.div`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.large2};
    color: ${props => props.theme.colours.dark};
    margin-bottom: ${props => props.theme.spacing.large};
`;

export const RunnerCardWrapper = styled.div`
    height: 75px;
    margin-top: 16px;

    &:nth-of-type(1) {
        margin-top: 0;
    }
`;

export const PlayItvWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
`;

export const Text = styled.p`
    font-size: ${props => props.theme.fontSize.medium};
    line-height: ${props => props.theme.lineHeight.normal};
    margin: ${props =>
        `0 ${props.theme.spacing.large} ${props.theme.spacing.large}`};
    text-align: center;
`;

export const Strong = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    color: ${props => props.theme.colours.textGreen};
`;

export const BetPromoWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CountDownTimerWrapper = styled.div`
    width: 100%;
    margin-bottom: 16px;

    @media (max-width: 1023px) {
        margin-bottom: 24px;
    }
`;

export const ButtonWrapper = styled.div`
    width: 100%;
`;

export const UpComingRoundsWrapper = styled.div`
    width: 100%;
    margin-bottom: ${props => props.theme.spacing.xxlarge};
`;
